import { Controller } from "../../Controller";
import { GetCasoCobrancaFatoService } from "../../../Services/Cobranca/CasoCobrancaFato/CasoCobrancaFatoServices";

export async function GetCosoCobrancaFatoController(idChaveErp: string) {
    return Controller(GetCasoCobrancaFatoService(idChaveErp));
}
